import { agentsRequest } from '@/services/request';

/** 工具审批决策项 */
export interface ToolApprovalDecision {
  toolCallId: string;
  approved: boolean;
  reason?: string;
}

/** 工具审批响应 */
export interface ToolApprovalResponse {
  success: boolean;
  message: string;
}

/**
 * 提交工具审批决策
 */
export async function submitToolApproval(
  sessionId: string,
  messageId: string,
  decisions: ToolApprovalDecision[],
) {
  const response = await agentsRequest.post<ToolApprovalResponse>(
    `/agent/v1/sessions/${sessionId}/messages/${messageId}/tool-approval`,
    { decisions },
  );
  return response.data;
}
